import { defineStore } from "pinia";
import axios from "axios";

const MINIFLUX_BASE_URL = process.env.VUE_APP_MINIFLUX_SERVICE?.replace(/\/$/, "") || "";

export const useNewsStore = defineStore("news", {
  state: () => ({
    isSubmitting: false,
    createdNewsId: null,
    error: null,
  }),
  actions: {
    async createNews(sourceId, payload) {
      this.isSubmitting = true;
      this.error = null;
      this.createdNewsId = null;

      try {
        const url = `${MINIFLUX_BASE_URL}/api/sources/${sourceId}/news`;
        const { data } = await axios.post(url, payload);

        this.createdNewsId = data?.id ?? null;
        window.storeLK?.createNotify("Новость поставлена в пайплайн", "success");
        return true;
      } catch (error) {
        this.error = error?.response?.data?.messages?.join(", ") || error?.message || "Ошибка публикации новости";
        window.storeLK?.createNotify(this.error, "error");
        return false;
      } finally {
        this.isSubmitting = false;
      }
    },
  },
});
